import { create } from "@storybook/theming"
export default create({
  base: 'light', // this will inherit the base properties of Storybooks'light theme

  // Base color
  colorSecondary: '#212A3E', 

  // UI
  appBg: '#F1F6F9', // Sidebar
  appContentBg: '#F2F7FF',
  appBorderColor: 'rgba(0,0,0,.1)',
  appBorderRadius: 4,

  // Typography
  fontBase: '"Open Sans", sans-serif',
  fontCode: 'monospace',

  // Text colors
  textColor: '#742DD2',
  textInverseColor: '#FFFFFF',
  textMutedColor: '#000000',

  // Toolbar default and active colors
  barTextColor: '#000000',
  barSelectedColor: '#212A3E',
  barBg: '#F1F6F9',

  booleanBg: '#A0BFE0',
  booleanSelectedBg: '#FAFAF6',
  // Form colors
  inputBg: '#FFFFFF',
  inputBorder: 'rgba(0,0,0,.3)',
  inputTextColor: '#000000',
  inputBorderRadius: 4,

  buttonBg: '#A0BFE0',
  // Brand assets
  brandTitle: 'CustomAFK',
  brandUrl: 'https://www.instagram.com/quangquang___/',
})
